import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import TabletIcon from "@material-ui/icons/Tablet";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import BlockIcon from "@material-ui/icons/Block";
import TonalityIcon from "@material-ui/icons/Tonality";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import TextureIcon from "@material-ui/icons/Texture";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import BlurOnIcon from "@material-ui/icons/BlurOn";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import FlipIcon from "@material-ui/icons/Flip";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import StarsIcon from "@material-ui/icons/Stars";
import AppsIcon from "@material-ui/icons/Apps";
import TvIcon from "@material-ui/icons/Tv";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import ShuffleIcon from "@material-ui/icons/Shuffle";
import FilterDramaIcon from "@material-ui/icons/FilterDrama";
import Brightness3Icon from "@material-ui/icons/Brightness3";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import { STAGGER_EFFECT_TRANSITION_IDS } from "./escapeRoomStaggerEffectTransitions";

export const STAGGER_PANEL_TRANSITION_IDS = new Set([
	"comic",
	"scatter",
	"reveal",
	...STAGGER_EFFECT_TRANSITION_IDS,
]);

export const CANVAS_WIDTH = 960;
export const CANVAS_HEIGHT = 540;

export const PAGE_TRANSITIONS = [
	{ id: "none", label: "Sin animación", Icon: BlockIcon },
	{ id: "fade", label: "Fundido", Icon: TonalityIcon },
	{ id: "slideLeft", label: "Deslizar izquierda", Icon: KeyboardArrowLeftIcon },
	{ id: "slideRight", label: "Deslizar derecha", Icon: KeyboardArrowRightIcon },
	{ id: "slideUp", label: "Deslizar arriba", Icon: KeyboardArrowUpIcon },
	{ id: "slideDown", label: "Deslizar abajo", Icon: KeyboardArrowDownIcon },
	{ id: "zoom", label: "Zoom", Icon: ZoomInIcon },
	{ id: "glitch", label: "Glitch", Icon: TextureIcon },
	{ id: "comic", label: "Cómic", Icon: ViewModuleIcon },
	{ id: "scatter", label: "Dispersión", Icon: BlurOnIcon },
	{ id: "reveal", label: "Instantánea", Icon: PhotoCameraIcon },
	{ id: "materialize", label: "Materialización", Icon: StarsIcon },
	{ id: "build", label: "Ensamblaje", Icon: AppsIcon },
	{ id: "static", label: "Estática TV", Icon: TvIcon },
	{ id: "thermal", label: "Neón", Icon: Brightness7Icon },
	{ id: "softGlitch", label: "Glitch fuerte", Icon: ShuffleIcon },
	{ id: "mist", label: "Niebla", Icon: FilterDramaIcon },
	{ id: "shadow", label: "Penumbra", Icon: Brightness3Icon },
	{ id: "omen", label: "Presagio", Icon: VisibilityOffIcon },
	{ id: "clinical", label: "Monitor clínico", Icon: LocalHospitalIcon },
	{ id: "flashExit", label: "Destello de salida", Icon: HighlightOffIcon },
	{ id: "flashEnter", label: "Destello de entrada", Icon: FlashOnIcon },
	{ id: "flashBoth", label: "Destello salida y entrada", Icon: FlipIcon },
];

/** Animación de entrada del elemento al mostrar la página (Premium / editor avanzado). */
export const ELEMENT_ENTRY_ANIMATIONS = PAGE_TRANSITIONS;

export const ENTRY_ANIMATION_SPEEDS = [
	{ ms: 200, label: "Muy rápida" },
	{ ms: 350, label: "Rápida" },
	{ ms: 500, label: "Normal" },
	{ ms: 700, label: "Lenta" },
	{ ms: 1000, label: "Muy lenta" },
];

/** Retiradas del selector; si siguen en JSON antiguo se normalizan a "fade" al cargar páginas o en reproducción web. */
const RETIRED_PAGE_TRANSITION_IDS = new Set([
	"brushStroke",
	"brushStrokeReverse",
	"mosaic",
	"iris",
	"shutter",
	"pageTurn",
	"sand",
]);

export function normalizePageTransitionId(id) {
	const v = id || "none";
	return RETIRED_PAGE_TRANSITION_IDS.has(v) ? "fade" : v;
}

export function normalizeEntryAnimationId(id) {
	return normalizePageTransitionId(id);
}

/** CSS @keyframes compartidos (páginas y elementos). */
export const ER_ANIMATION_KEYFRAMES_CSS = `
	@keyframes er-page-fade { from { opacity: 0; } to { opacity: 1; } }
	@keyframes er-page-slideLeft { from { opacity: 0; transform: translateX(20%); } to { opacity: 1; transform: translateX(0); } }
	@keyframes er-page-slideRight { from { opacity: 0; transform: translateX(-20%); } to { opacity: 1; transform: translateX(0); } }
	@keyframes er-page-slideUp { from { opacity: 0; transform: translateY(20%); } to { opacity: 1; transform: translateY(0); } }
	@keyframes er-page-slideDown { from { opacity: 0; transform: translateY(-20%); } to { opacity: 1; transform: translateY(0); } }
	@keyframes er-page-zoom { from { opacity: 0; transform: scale(0.92); } to { opacity: 1; transform: scale(1); } }
	@keyframes er-page-comic-panel {
		0% { opacity: 0; transform: scale(0.18) rotate(var(--er-comic-rot, -6deg)); }
		42% { opacity: 1; transform: scale(1.07) rotate(calc(var(--er-comic-rot, -6deg) * 0.22)); }
		62% { transform: scale(0.97) rotate(calc(var(--er-comic-rot, -6deg) * 0.06)); }
		100% { opacity: 1; transform: scale(1) rotate(0deg); }
	}
	@keyframes er-page-comic-bg {
		0% { opacity: 0; transform: scale(1.04); }
		100% { opacity: 1; transform: scale(1); }
	}
	@keyframes er-entry-fade { from { opacity: 0; } to { opacity: 1; } }
	@keyframes er-entry-slideLeft { from { opacity: 0; transform: translateX(16%); } to { opacity: 1; transform: translateX(0); } }
	@keyframes er-entry-slideRight { from { opacity: 0; transform: translateX(-16%); } to { opacity: 1; transform: translateX(0); } }
	@keyframes er-entry-slideUp { from { opacity: 0; transform: translateY(16%); } to { opacity: 1; transform: translateY(0); } }
	@keyframes er-entry-slideDown { from { opacity: 0; transform: translateY(-16%); } to { opacity: 1; transform: translateY(0); } }
	@keyframes er-entry-zoom { from { opacity: 0; transform: scale(0.88); } to { opacity: 1; transform: scale(1); } }
	@keyframes er-entry-glitch {
		0% { opacity: 0; transform: translate(-2px, 1px); filter: drop-shadow(3px 0 #ff00c8) drop-shadow(-3px 0 #00e5ff); }
		22% { opacity: 1; transform: translate(3px, -2px); filter: drop-shadow(-4px 1px #ff00c8) drop-shadow(4px -1px #00e5ff); }
		44% { transform: translate(-2px, 2px); filter: drop-shadow(2px -2px #ff00c8) drop-shadow(-2px 2px #00e5ff); }
		66% { transform: translate(1px, 0); filter: drop-shadow(-1px 0 #ff00c8) drop-shadow(1px 0 #00e5ff); }
		100% { opacity: 1; transform: translate(0); filter: none; }
	}
	@keyframes er-page-scatter-panel {
		0% { opacity: 0; transform: translate(var(--er-scatter-x, 0), var(--er-scatter-y, 48px)) scale(0.88); filter: blur(8px); }
		55% { opacity: 1; filter: blur(1px); }
		100% { opacity: 1; transform: translate(0, 0) scale(1); filter: none; }
	}
	@keyframes er-page-scatter-bg {
		from { opacity: 0; }
		to { opacity: 1; }
	}
	@keyframes er-page-reveal-panel {
		0% {
			opacity: 0;
			transform: translateY(var(--er-reveal-drop, -140px)) rotate(var(--er-reveal-tilt, -7deg)) scale(0.88);
			filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0));
		}
		20% { opacity: 1; }
		70% {
			transform: translateY(7px) rotate(calc(var(--er-reveal-tilt, -7deg) * 0.12)) scale(1.035);
			filter: drop-shadow(0 16px 14px rgba(0, 0, 0, 0.32));
		}
		84% {
			transform: translateY(-5px) rotate(calc(var(--er-reveal-tilt, -7deg) * 0.04)) scale(0.985);
			filter: drop-shadow(0 8px 10px rgba(0, 0, 0, 0.18));
		}
		100% {
			opacity: 1;
			transform: translateY(0) rotate(0deg) scale(1);
			filter: drop-shadow(0 3px 7px rgba(0, 0, 0, 0.1));
		}
	}
	@keyframes er-page-reveal-bg {
		0% { opacity: 0; filter: brightness(0.5) saturate(0.88); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-entry-scatter {
		from { opacity: 0; transform: translateY(20px) scale(0.9); filter: blur(5px); }
		to { opacity: 1; transform: translateY(0) scale(1); filter: none; }
	}
	@keyframes er-page-materialize-panel {
		0% {
			opacity: 0;
			filter: blur(var(--er-mat-blur, 14px)) saturate(0.12) brightness(1.85) contrast(0.55)
				drop-shadow(0 0 calc(18px * var(--er-mat-glow, 0.6)) rgba(186, 220, 255, var(--er-mat-glow, 0.6)));
		}
		28% {
			opacity: 0.5;
			filter: blur(calc(var(--er-mat-blur, 14px) * 0.45)) saturate(0.4) brightness(1.45) contrast(0.78)
				drop-shadow(0 0 calc(12px * var(--er-mat-glow, 0.6)) rgba(200, 225, 255, calc(var(--er-mat-glow, 0.6) * 0.7)));
		}
		62% {
			opacity: 0.9;
			filter: blur(2px) saturate(0.82) brightness(1.06) contrast(1);
		}
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-page-materialize-bg {
		0% { opacity: 0; filter: blur(4px) saturate(0.35) brightness(0.65); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-entry-materialize {
		0% { opacity: 0; filter: blur(12px) saturate(0.15) brightness(1.7); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-page-build-panel {
		0% {
			opacity: 0;
			transform: translate3d(var(--er-build-dx, 0px), var(--er-build-dy, 16px), 0) scale(1.015);
			filter: drop-shadow(0 12px 20px rgba(0, 0, 0, 0.30));
		}
		62% {
			opacity: 1;
			transform: translate3d(0, 0, 0) scale(1);
			filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.16));
		}
		86% {
			transform: translate3d(0, -1px, 0) scale(1);
			filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.10));
		}
		100% {
			opacity: 1;
			transform: none;
			filter: none;
		}
	}
	@keyframes er-page-build-bg {
		0% {
			opacity: 0;
			filter: brightness(0.88) contrast(1.04);
		}
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-entry-build {
		0% {
			opacity: 0;
			transform: translate3d(0, 16px, 0) scale(1.015);
			filter: drop-shadow(0 12px 20px rgba(0, 0, 0, 0.28));
		}
		62% {
			opacity: 1;
			transform: translate3d(0, 0, 0) scale(1);
			filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.14));
		}
		86% {
			transform: translate3d(0, -1px, 0);
			filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));
		}
		100% {
			opacity: 1;
			transform: none;
			filter: none;
		}
	}
	@media (prefers-reduced-motion: reduce) {
		@keyframes er-page-build-panel {
			0% { opacity: 0; }
			100% { opacity: 1; transform: none; filter: none; }
		}
		@keyframes er-entry-build {
			0% { opacity: 0; }
			100% { opacity: 1; transform: none; filter: none; }
		}
	}
	@keyframes er-page-static-panel {
		0% { opacity: 0.12; filter: contrast(4) brightness(2.2) blur(2px) saturate(0); }
		18% { opacity: 0.62; filter: contrast(3) brightness(1.85) blur(1.5px); }
		36% { opacity: 0.32; filter: contrast(2.6) brightness(2) blur(1px); }
		54% { opacity: 0.78; filter: contrast(1.7) brightness(1.35) blur(0.5px); }
		72% { opacity: 0.52; filter: contrast(1.25) brightness(1.12); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-page-static-bg {
		0% { opacity: 0; filter: contrast(2.2) brightness(1.5) saturate(0); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-entry-static {
		0%, 35% { opacity: 0.35; filter: contrast(3) brightness(1.8) blur(1px); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-page-thermal-panel {
		0% { opacity: 0; transform: scale(0.88); filter: blur(7px) brightness(2.4) hue-rotate(var(--er-neon-hue, 0deg)) drop-shadow(0 0 16px rgba(0, 255, 220, 0.95)) drop-shadow(0 0 32px rgba(255, 0, 200, 0.65)); }
		14% { opacity: 1; transform: scale(1.06); filter: blur(0) brightness(1.85) hue-rotate(var(--er-neon-hue, 0deg)) saturate(1.8) drop-shadow(0 0 20px rgba(0, 255, 220, 0.9)) drop-shadow(0 0 40px rgba(255, 0, 200, 0.5)); }
		32% { transform: scale(0.98); filter: brightness(1.3) hue-rotate(calc(var(--er-neon-hue, 0deg) * 0.35)) drop-shadow(0 0 10px rgba(0, 255, 220, 0.45)); }
		52% { transform: scale(1.01); filter: brightness(1.1) drop-shadow(0 0 5px rgba(0, 255, 220, 0.2)); }
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-thermal-bg {
		0% { opacity: 0; filter: brightness(0.35) saturate(1.5) contrast(1.25); }
		18% { opacity: 0.75; filter: brightness(1.35) saturate(1.7); }
		42% { opacity: 1; filter: brightness(1.1); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-entry-thermal {
		0% { opacity: 0; transform: scale(0.9); filter: blur(6px) brightness(2) drop-shadow(0 0 14px rgba(0, 255, 220, 0.85)); }
		38% { opacity: 1; transform: scale(1.04); filter: brightness(1.45) drop-shadow(0 0 10px rgba(0, 255, 220, 0.5)); }
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-softGlitch-panel {
		0% { opacity: 0; transform: translate(var(--er-glitch-x, 9px), var(--er-glitch-y, -4px)) skewX(var(--er-glitch-skew, 5deg)) scale(1.08); filter: drop-shadow(calc(var(--er-glitch-x, 9px) * 1.3) 0 #ff00c8) drop-shadow(calc(var(--er-glitch-x, 9px) * -1.3) 0 #00e5ff) contrast(2.6) saturate(2) brightness(1.55); }
		10% { opacity: 1; transform: translate(calc(var(--er-glitch-x, 9px) * -0.9), calc(var(--er-glitch-y, -4px) * -0.5)) skewX(calc(var(--er-glitch-skew, 5deg) * -1.6)) scale(1.04); filter: drop-shadow(-8px 2px #ff00c8) drop-shadow(8px -2px #00e5ff) contrast(2.3) brightness(1.35); }
		20% { transform: translate(calc(var(--er-glitch-x, 9px) * 0.55), 3px) skewX(calc(var(--er-glitch-skew, 5deg) * 0.7)) scale(0.97); filter: drop-shadow(6px -1px #ff00c8) drop-shadow(-6px 1px #00e5ff) contrast(2.8) brightness(1.7); }
		30% { transform: translate(calc(var(--er-glitch-x, 9px) * -0.45), -2px) skewX(calc(var(--er-glitch-skew, 5deg) * -1.1)) scale(1.03); }
		40% { transform: translate(4px, 1px) skewX(2deg) scale(0.99); filter: contrast(2) drop-shadow(4px 0 rgba(255,0,200,0.7)) drop-shadow(-4px 0 rgba(0,229,255,0.7)); }
		50% { transform: translate(-3px, -1px) skewX(-2deg); filter: contrast(1.7); }
		62% { transform: translate(2px, 0) skewX(1deg) scale(1.01); filter: drop-shadow(2px 0 rgba(255,0,200,0.4)) drop-shadow(-2px 0 rgba(0,229,255,0.4)); }
		75% { transform: translate(-1px, 0) skewX(-0.5deg); filter: contrast(1.25); }
		88% { transform: translate(1px, 0); filter: contrast(1.08); }
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-softGlitch-bg {
		0% { opacity: 0; filter: contrast(2) saturate(0.6) brightness(1.3); }
		30% { opacity: 0.85; filter: contrast(1.5) saturate(0.85); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-entry-softGlitch {
		0% { opacity: 0; transform: translate(8px, -3px) skewX(4deg); filter: drop-shadow(6px 0 #ff00c8) drop-shadow(-6px 0 #00e5ff) contrast(2.4); }
		50% { opacity: 1; transform: translate(-3px, 1px) skewX(-2deg); filter: drop-shadow(3px 0 rgba(255,0,200,0.6)) drop-shadow(-3px 0 rgba(0,229,255,0.6)); }
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-mist-content-in {
		0% { filter: blur(20px) brightness(0.58) saturate(0.3) contrast(0.92); }
		30% { filter: blur(11px) brightness(0.78) saturate(0.5) contrast(0.96); }
		58% { filter: blur(4px) brightness(0.94) saturate(0.82); }
		100% { filter: none; }
	}
	@keyframes er-page-mist-panel {
		0% { opacity: 0; transform: translateY(calc(14px + var(--er-mist-drift, 0px))) scale(0.97); filter: blur(calc(18px + var(--er-mist-blur, 0px))) saturate(0.22) brightness(0.92) contrast(0.9); }
		18% { opacity: 0.3; filter: blur(14px) saturate(0.28) brightness(0.95); }
		38% { opacity: 0.62; transform: translateY(calc(5px + var(--er-mist-drift, 0px) * 0.35)) scale(0.99); filter: blur(8px) saturate(0.45) brightness(0.98); }
		58% { opacity: 0.84; filter: blur(3px) saturate(0.68); }
		78% { opacity: 0.95; filter: blur(1px); }
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-mist-bg {
		0% { opacity: 0; filter: blur(16px) saturate(0.2) brightness(0.62) contrast(0.9); }
		28% { opacity: 0.55; filter: blur(9px) saturate(0.35) brightness(0.78); }
		55% { opacity: 0.82; filter: blur(4px) saturate(0.62) brightness(0.9); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-entry-mist {
		0% { opacity: 0; transform: translateY(14px); filter: blur(14px) saturate(0.25) brightness(0.9); }
		45% { opacity: 0.78; filter: blur(4px) saturate(0.55); }
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-shadow-panel {
		0% { opacity: 0; transform: translateX(var(--er-shadow-x, 6px)) scale(1.15); filter: brightness(0.12) contrast(1.9) saturate(0.25) blur(4px); }
		18% { opacity: 0.28; transform: translateX(calc(var(--er-shadow-x, 6px) * 0.65)) scale(1.09); filter: brightness(0.32) contrast(1.7) blur(3px); }
		40% { opacity: 0.68; transform: translateX(calc(var(--er-shadow-x, 6px) * 0.25)) scale(1.03); filter: brightness(0.62) contrast(1.35) blur(1px); }
		65% { opacity: 0.88; transform: scale(0.99); filter: brightness(0.88) contrast(1.12); }
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-shadow-bg {
		0% { opacity: 0; filter: brightness(0.18) contrast(1.55) saturate(0.12); }
		42% { opacity: 0.78; filter: brightness(0.52) contrast(1.22); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-entry-shadow {
		0% { opacity: 0; transform: scale(1.12); filter: brightness(0.18) contrast(1.75) blur(3px); }
		52% { opacity: 0.82; filter: brightness(0.72); }
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-omen-panel {
		0% { opacity: 0; transform: rotate(var(--er-omen-tilt, 2deg)) translateY(10px) scale(0.93); filter: blur(5px) brightness(1.65) saturate(0.35) hue-rotate(278deg) drop-shadow(0 0 14px rgba(76, 29, 149, 0.75)); }
		10% { opacity: 0.18; transform: rotate(calc(var(--er-omen-tilt, 2deg) * -0.9)) translateY(5px) scale(0.96); }
		20% { opacity: 0.88; filter: blur(2px) brightness(1.35) hue-rotate(265deg) drop-shadow(0 0 10px rgba(88, 28, 135, 0.55)); }
		30% { opacity: 0.38; transform: rotate(calc(var(--er-omen-tilt, 2deg) * 0.55)) scale(1.02); }
		40% { opacity: 0.96; filter: brightness(1.12) hue-rotate(252deg); }
		50% { opacity: 0.48; }
		60% { opacity: 1; transform: rotate(calc(var(--er-omen-tilt, 2deg) * -0.25)) scale(0.99); filter: brightness(1.04); }
		72% { opacity: 0.7; }
		82% { opacity: 1; }
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-omen-bg {
		0% { opacity: 0; filter: brightness(0.35) saturate(0.3) hue-rotate(285deg) contrast(1.35); }
		28% { opacity: 0.55; filter: brightness(0.65) hue-rotate(272deg); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-entry-omen {
		0% { opacity: 0; transform: rotate(2.5deg) scale(0.94); filter: brightness(1.55) hue-rotate(280deg) drop-shadow(0 0 12px rgba(76, 29, 149, 0.65)); }
		45% { opacity: 0.65; }
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-clinical-panel {
		0% {
			opacity: 0;
			transform: translateY(var(--er-clinical-rise, 8px)) skewX(var(--er-clinical-skew, 0.5deg)) scale(0.96);
			filter: blur(7px) brightness(1.35) saturate(0.45) hue-rotate(-22deg)
				drop-shadow(0 0 calc(14px * var(--er-clinical-glow, 0.5)) rgba(16, 185, 129, calc(0.55 + var(--er-clinical-glow, 0.5) * 0.4)));
		}
		18% {
			opacity: 0.55;
			filter: blur(3px) brightness(1.18) saturate(0.75) hue-rotate(-12deg)
				drop-shadow(0 0 10px rgba(16, 185, 129, 0.45));
		}
		36% {
			opacity: 1;
			transform: translateY(0) skewX(0deg) scale(1.035);
			filter: brightness(1.1) saturate(1.05)
				drop-shadow(0 0 16px rgba(203, 255, 151, 0.55));
		}
		52% {
			transform: scale(0.985);
			filter: brightness(1.02) drop-shadow(0 0 6px rgba(16, 185, 129, 0.25));
		}
		70% {
			transform: scale(1.012);
			filter: brightness(1.04) drop-shadow(0 0 8px rgba(203, 255, 151, 0.3));
		}
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-page-clinical-bg {
		0% { opacity: 0; filter: brightness(0.4) saturate(1.2) hue-rotate(-20deg) contrast(1.15); }
		22% { opacity: 0.55; filter: brightness(0.72) saturate(1.1) hue-rotate(-10deg); }
		55% { opacity: 0.92; filter: brightness(0.95) saturate(1.05); }
		100% { opacity: 1; filter: none; }
	}
	@keyframes er-entry-clinical {
		0% {
			opacity: 0;
			transform: translateY(10px) scale(0.96);
			filter: blur(6px) brightness(1.3) hue-rotate(-18deg) drop-shadow(0 0 12px rgba(16, 185, 129, 0.55));
		}
		38% {
			opacity: 1;
			transform: scale(1.03);
			filter: brightness(1.08) drop-shadow(0 0 10px rgba(203, 255, 151, 0.4));
		}
		100% { opacity: 1; transform: none; filter: none; }
	}
	@keyframes er-entry-reveal {
		0% { opacity: 0; transform: translateY(-52px) rotate(-6deg) scale(0.9); filter: drop-shadow(0 0 0 rgba(0,0,0,0)); }
		72% { transform: translateY(5px) rotate(1.5deg) scale(1.03); filter: drop-shadow(0 10px 8px rgba(0,0,0,0.22)); }
		100% { opacity: 1; transform: translateY(0) rotate(0) scale(1); filter: drop-shadow(0 2px 5px rgba(0,0,0,0.1)); }
	}
	@keyframes er-entry-comic {
		0% { opacity: 0; transform: scale(1.28) rotate(-3.5deg); filter: contrast(1.28) saturate(1.3); }
		32% { opacity: 1; transform: scale(0.94) rotate(1.8deg); }
		58% { transform: scale(1.035) rotate(-0.6deg); }
		100% { opacity: 1; transform: scale(1) rotate(0); filter: none; }
	}
`;

/** Overlay de glitch de pantalla completa (transición entre páginas). */
export const PAGE_GLITCH_OVERLAY_CSS = `
	@keyframes er-page-glitch-overlay-end {
		0%, 75% { opacity: 1; }
		100% { opacity: 0; visibility: hidden; }
	}
	@keyframes er-page-glitch-chroma-a {
		0% { transform: translate(-10px, 0) skewX(-2deg); opacity: 0.85; }
		18% { transform: translate(8px, -4px) skewX(1deg); opacity: 0.55; }
		36% { transform: translate(-6px, 3px); opacity: 0.7; }
		54% { transform: translate(5px, 1px); opacity: 0.35; }
		72% { transform: translate(-2px, 0); opacity: 0.15; }
		100% { transform: translate(0); opacity: 0; }
	}
	@keyframes er-page-glitch-chroma-b {
		0% { transform: translate(10px, 0) skewX(2deg); opacity: 0.85; }
		18% { transform: translate(-8px, 3px) skewX(-1deg); opacity: 0.55; }
		36% { transform: translate(6px, -2px); opacity: 0.7; }
		54% { transform: translate(-4px, -1px); opacity: 0.35; }
		72% { transform: translate(2px, 0); opacity: 0.15; }
		100% { transform: translate(0); opacity: 0; }
	}
	@keyframes er-page-glitch-scan-move {
		0% { transform: translateY(-100%); opacity: 0.9; }
		100% { transform: translateY(100%); opacity: 0; }
	}
	@keyframes er-page-glitch-bars {
		0%, 100% { opacity: 0; }
		8% { opacity: 0.9; transform: translateX(-6px); }
		16% { opacity: 0.7; transform: translateX(8px); }
		24% { opacity: 0.85; transform: translateX(-4px); }
		32% { opacity: 0.5; transform: translateX(5px); }
		40% { opacity: 0.75; transform: translateX(-2px); }
		48% { opacity: 0.4; transform: translateX(3px); }
		56% { opacity: 0.2; transform: translateX(0); }
	}
	@keyframes er-page-glitch-flash {
		0%, 100% { opacity: 0; }
		6% { opacity: 0.55; }
		12% { opacity: 0; }
		20% { opacity: 0.35; }
		28% { opacity: 0; }
	}
	@keyframes er-page-glitch-band-1 {
		0%, 100% { transform: translateX(0); }
		15% { transform: translateX(-12px); }
		30% { transform: translateX(9px); }
		45% { transform: translateX(-5px); }
	}
	@keyframes er-page-glitch-band-2 {
		0%, 100% { transform: translateX(0); }
		18% { transform: translateX(10px); }
		33% { transform: translateX(-11px); }
		48% { transform: translateX(4px); }
	}
	@keyframes er-page-glitch-band-3 {
		0%, 100% { transform: translateX(0); }
		12% { transform: translateX(8px); }
		27% { transform: translateX(-9px); }
		42% { transform: translateX(6px); }
	}
	.er-page-glitch-overlay {
		position: absolute;
		inset: 0;
		z-index: 800;
		pointer-events: none;
		border-radius: inherit;
		overflow: hidden;
		animation: er-page-glitch-overlay-end var(--er-glitch-dur, 0.5s) ease-out forwards;
		backdrop-filter: contrast(1.4) saturate(1.35) brightness(1.05);
	}
	.er-page-glitch-overlay__band {
		position: absolute;
		left: -12px;
		right: -12px;
		height: 22%;
		pointer-events: none;
		mix-blend-mode: screen;
		opacity: 0.85;
	}
	.er-page-glitch-overlay__band--1 {
		top: 8%;
		background: linear-gradient(90deg, rgba(255, 0, 200, 0.35), transparent 70%);
		animation: er-page-glitch-band-1 0.44s steps(5) forwards;
	}
	.er-page-glitch-overlay__band--2 {
		top: 38%;
		background: linear-gradient(270deg, rgba(0, 229, 255, 0.35), transparent 70%);
		animation: er-page-glitch-band-2 0.44s steps(5) forwards;
	}
	.er-page-glitch-overlay__band--3 {
		top: 68%;
		background: linear-gradient(90deg, rgba(255, 0, 200, 0.28), transparent 65%);
		animation: er-page-glitch-band-3 0.44s steps(5) forwards;
	}
	.er-page-glitch-overlay__chroma {
		position: absolute;
		inset: -6px;
		pointer-events: none;
		mix-blend-mode: screen;
	}
	.er-page-glitch-overlay__chroma--a {
		background: linear-gradient(90deg, rgba(255, 0, 200, 0.62), transparent 50%);
		animation: er-page-glitch-chroma-a 0.42s steps(6) forwards;
	}
	.er-page-glitch-overlay__chroma--b {
		background: linear-gradient(270deg, rgba(0, 229, 255, 0.62), transparent 50%);
		animation: er-page-glitch-chroma-b 0.42s steps(6) forwards;
	}
	.er-page-glitch-overlay__scan {
		position: absolute;
		inset: 0;
		background: repeating-linear-gradient(
			0deg,
			transparent 0,
			transparent 2px,
			rgba(0, 0, 0, 0.12) 2px,
			rgba(0, 0, 0, 0.12) 4px
		);
		opacity: 0.5;
		animation: er-page-glitch-scan-move 0.38s linear forwards;
		mix-blend-mode: multiply;
	}
	.er-page-glitch-overlay__bars {
		position: absolute;
		inset: 0;
		background: linear-gradient(
			180deg,
			transparent 0%,
			transparent 18%,
			rgba(255, 255, 255, 0.14) 18%,
			rgba(255, 255, 255, 0.14) 22%,
			transparent 22%,
			transparent 48%,
			rgba(0, 0, 0, 0.2) 48%,
			rgba(0, 0, 0, 0.2) 52%,
			transparent 52%,
			transparent 72%,
			rgba(255, 255, 255, 0.1) 72%,
			rgba(255, 255, 255, 0.1) 76%,
			transparent 76%
		);
		animation: er-page-glitch-bars 0.45s steps(4) forwards;
		mix-blend-mode: overlay;
	}
	.er-page-glitch-overlay__flash {
		position: absolute;
		inset: 0;
		background: #fff;
		animation: er-page-glitch-flash 0.45s steps(3) forwards;
		mix-blend-mode: soft-light;
	}
`;

export const TRANSITION_SPEEDS = [
	{ ms: 150, label: "Muy rápida" },
	{ ms: 250, label: "Rápida" },
	{ ms: 350, label: "Normal" },
	{ ms: 500, label: "Lenta" },
	{ ms: 700, label: "Muy lenta" },
	{ ms: 1000, label: "Extra lenta" },
	{ ms: 1400, label: "Cinemática" },
];

export const DEFAULT_GAME_TIME_SECONDS = 1500;

export const VIEWPORTS = [
	{ id: "desktop", label: "Escritorio", shortLabel: "Escritorio", Icon: DesktopWindowsIcon, width: 960, height: 540 },
	{ id: "tablet", label: "Tablet", shortLabel: "Tablet", Icon: TabletIcon, width: 768, height: 540 },
	{ id: "mobile", label: "Móvil", shortLabel: "Móvil", Icon: PhoneIphoneIcon, width: 360, height: 780 },
];

/** Altura reservada en el lienzo (px lógicos) donde el HUD de tiempo tapa contenido en juego. */
export const PLAY_HUD_RESERVED_ZONE_HEIGHT = {
	desktop: 52,
	tablet: 52,
	mobile: 52,
};

export function getPlayHudReservedZoneHeight(viewportId) {
	return PLAY_HUD_RESERVED_ZONE_HEIGHT[viewportId] ?? PLAY_HUD_RESERVED_ZONE_HEIGHT.desktop;
}

export const MODAL_SIZES = [
	{ id: "small", label: "Pequeño", width: 400, height: 300 },
	{ id: "medium", label: "Mediano", width: 640, height: 480 },
	{ id: "large", label: "Grande", width: 800, height: 600 },
];

export const DESKTOP = { width: 960, height: 540 };

export const REGISTRATION_PAGE_ID = "registration";

/** Escenario reservado: solo puede contener la página de registro. */
export const REGISTRATION_SCENARIO_ID = "__registration__";

export function isRegistrationScenario(scenario) {
	if (!scenario) return false;
	return scenario.isRegistration === true || String(scenario.id) === REGISTRATION_SCENARIO_ID;
}

export function createRegistrationScenario(order = 0) {
	return { id: REGISTRATION_SCENARIO_ID, name: "Registro", icon: "assignment", order, isRegistration: true };
}

/** Acento por defecto del escape room (registro / UI). */
export const PRIMARY_RED = "#7D00FC";
export const PRIMARY_RGBA = "rgba(125, 0, 252, 1)";
